module.exports = __webpack_public_path__ + "static/img/gold-pig.1df4b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/gold-pig.png
// module id = cgc+
// module chunks = 216